import React from 'react'
import WorkSummaryDetailViewJobAssignmentTable from './WorkSummaryDetailViewJobAssignmentTable'

const WorkSummaryDetailView = ({
  workSummary,
  jobAssignmentsTableTitle,
  getJobAssignments,
}) => {
  if (!workSummary) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <svg
            className="mx-auto h-12 w-12 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          <p className="mt-4 text-lg font-medium text-gray-600">
            No work summary selected
          </p>
          <p className="mt-1 text-sm text-gray-500">
            Select a staff member to view their work summary
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="h-full p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">
          {workSummary.staff.firstName} {workSummary.staff.lastName}
        </h2>
        <p className="text-sm text-gray-500 mt-1">{jobAssignmentsTableTitle}</p>
      </div>

      <div className="border-t border-gray-200 pt-4">
        {renderTable(getJobAssignments(workSummary))}
      </div>
    </div>
  )
}

const renderTable = (jobAssignments) => {
  if (jobAssignments.length <= 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <svg
            className="mx-auto h-12 w-12 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
            />
          </svg>
          <p className="mt-4 text-lg font-medium text-gray-600">
            No Completed Job
          </p>
        </div>
      </div>
    )
  }
  return (
    <WorkSummaryDetailViewJobAssignmentTable jobAssignments={jobAssignments} />
  )
}

export default WorkSummaryDetailView

export const withWorkSummaryDetailView =
  (jobAssignmentsTableTitle, getJobAssignments) => (props) => (
    <WorkSummaryDetailView
      jobAssignmentsTableTitle={jobAssignmentsTableTitle}
      getJobAssignments={getJobAssignments}
      {...props}
    />
  )
